import initialState from "./initialState";

const mutations = {
  setUserPremiumPlanInformation: (state, data) => (state.userPremiumPlanInformation = data),
  setClientPremiumPlan: (state, isClientPremium) => (state.isClientPremium = isClientPremium),
  resetModule:(state)=>(Object.assign(state,initialState())),
  setBillingInformation: (state, billing) => (state.billing = billing),
  setAccountClients: (state, data) => (state.accountClients = data),
  setUserInformation: (state, user) => state.user = user
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js